"use strict";

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilterSliderProps = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../hooks");

var utility_1 = require("../utility");

var useReactSliderProps_1 = require("./react-slider/useReactSliderProps");

var useFilterSliderProps = function useFilterSliderProps(filter) {
  var _a;

  var _ref = (0, hooks_1.useAnalytics)(),
      track = _ref.track;

  var urlSearchParam = new URLSearchParams(window.location.search);

  var _react_1$default$useS = react_1.default.useState(JSON.parse((_a = urlSearchParam.get(filter.handle)) !== null && _a !== void 0 ? _a : "[0,0]")),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      filterValue = _react_1$default$useS2[0],
      setFilterValue = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState([0, 0]),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      filterRange = _react_1$default$useS4[0],
      setFilterRange = _react_1$default$useS4[1];

  var handleChange = react_1.default.useCallback(function (value) {
    utility_1.debug.log("useFilterSliderProps", "handleChange[value]", value);
    setFilterValue([parseInt("".concat(value[0])), parseInt("".concat(value[1]))]);
    track({
      eventName: "filterChange",
      payload: {
        name: filter.name,
        value: "".concat(value[0], ":").concat(value[1])
      }
    });
  }, [filter]);
  var handleRange = react_1.default.useCallback(function (value) {
    setFilterRange([parseInt("".concat(value[0])), parseInt("".concat(value[1]))]);
  }, [filter]);
  react_1.default.useEffect(function () {
    var handler = function handler(event) {
      setFilterValue(event.detail.value);
    };

    window.addEventListener("@usereactify/search:filter:".concat(filter.handle, ":update"), handler);
    return function () {
      return window.removeEventListener("@usereactify/search:filter:".concat(filter.handle, ":update"), handler);
    };
  }, []);
  var reactSliderProps = (0, useReactSliderProps_1.useReactSliderProps)(filter, filterValue, filterRange, handleChange);
  var filterSliderProps = react_1.default.useMemo(function () {
    return {
      handleChange: handleChange,
      handleRange: handleRange,
      filter: filter,
      value: filterValue,
      range: filterRange,
      reactSliderProps: reactSliderProps
    };
  }, [handleChange, handleRange, filter, filterValue, filterRange, reactSliderProps]);
  return filterSliderProps;
};

exports.useFilterSliderProps = useFilterSliderProps;